"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eight/sections/companySection.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { SmartImage } from "@/Components";
import { FC, ComponentProps } from "react";

type HomeEightCompanySectionCompaniesItem = {
    /** Detected variants: "/Templates/Doccure/img/company/company-01.svg`" | "/Templates/Doccure/img/company/company-02.svg`" | "/Templates/Doccure/img/company/company-03.svg`" | "/Templates/Doccure/img/company/company-04.svg`" | "/Templates/Doccure/img/company/company-05.svg`" | "/Templates/Doccure/img/company/company-06.svg`" | "/Templates/Doccure/img/company/company-07.svg`" */
    src: string;
    /** Detected variants: "company-01.svg" | "company-02.svg" | "company-03.svg" | "company-04.svg" | "company-05.svg" | "company-06.svg" | "company-07.svg" */
    text: string;
    /** Detected variants: "img" */
    alt?: string;
};
export type HomeEightCompanySectionGeneratedProps = {
    companies?: HomeEightCompanySectionCompaniesItem[];
    /** Default: "1s" */
    divDataWowDuration?: string;
    divDiv0Swiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
};

const HomeEightCompanySectionGenerated: FC<HomeEightCompanySectionGeneratedProps> = ({
    companies = [],
    divDataWowDuration = "1s",
    divDiv0Swiper0SwiperProps,
}) => {
    return (
        <div className="company-section company-section-eight wow fadeOut" data-wow-duration={divDataWowDuration}>
            <div className="container">
                <Swiper modules={[Autoplay]} slidesPerView={6} loop speed={2000} autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                }} breakpoints={{
                    1400: { slidesPerView: 6 },
                    1200: { slidesPerView: 5 },
                    992: { slidesPerView: 4 },
                    768: { slidesPerView: 3 }
                }} className="company-slider" {...(divDiv0Swiper0SwiperProps ?? {})}>
                    {companies.map((img, index) => (
                        <SwiperSlide key={index} className="slide-item">
                            <SmartImage src={img.src} alt={img.alt ?? "img"} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default HomeEightCompanySectionGenerated;
